import { MNSproCloudApi } from '..';
import { ReferenceIdMigrationEntryDto } from '../api/v2';

/**
 * Service for migrating user reference IDs from SchILD NRW V2 to V3
 * using the mapping CSV produced by the SchILD export tool.
 */
export class SchildMigrationService {
  private static getApi(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);

    return MNSproCloudApi.V2.UsersApiFactory(config);
  }

  /**
   * Uploads the SchILD migration CSV file to the backend. The raw file is sent
   * as multipart form data so the backend owns decoding (e.g. UTF-8 vs ANSI).
   *
   * @param authToken Active MNSpro Cloud access token.
   * @param organizationId Organization the migration applies to.
   * @param apply When false, a preview is returned; when true, the new
   *   reference IDs are written and the returned list reflects the result.
   * @param file The migration CSV file produced by the SchILD export tool.
   * @returns One entry per CSV row with old/new reference ID and state.
   */
  static async migrateReferenceIds(
    authToken: string,
    organizationId: string,
    apply: boolean,
    file: File,
  ): Promise<ReferenceIdMigrationEntryDto[]> {
    const api = SchildMigrationService.getApi(authToken);
    // Windows reports the MIME type of a .csv file as
    // "application/vnd.ms-excel"; the backend only accepts "text/csv". Re-wrap
    // the file with the expected type (the bytes are unchanged).
    const csvFile =
      file.type === 'text/csv' ? file : new File([file], file.name, { type: 'text/csv' });
    const response = await api.migrateReferenceIds(organizationId, apply, undefined, csvFile);

    return response.data;
  }
}
